import {recordSchema} from '@lightweightform/storage';
import {importSchema} from './import-form/import-form.schema';

/**
 * App schema.
 */
export const appSchema = recordSchema({
  'import-form': importSchema
});
